import { render, staticRenderFns } from "./addStudentToGroupForm.vue?vue&type=template&id=2bbb681c&"
import script from "./addStudentToGroupForm.vue?vue&type=script&lang=js&"
export * from "./addStudentToGroupForm.vue?vue&type=script&lang=js&"
import style0 from "./addStudentToGroupForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports